import { render, staticRenderFns } from "./DeudaShowData.vue?vue&type=template&id=0b4b369b"
import script from "./DeudaShowData.vue?vue&type=script&lang=js"
export * from "./DeudaShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports